import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Intro from "../../../../elements/blocks/intro";
import CustomFieldForm from "../../../../elements/custom-fields/custom-field-form";
export default function ContactFieldNew() {
    const { t } = useTranslation();
    return (_jsxs(Fragment, { children: [_jsx(Intro, { name: t("fields.contact-fields.new-contact-field"), breadcrumbs: [
                    {
                        name: t("settings"),
                        link: "/settings",
                    },
                    {
                        name: t("fields.fields"),
                        link: "/settings/fields",
                    },
                    {
                        name: t("contacts.contacts"),
                        link: "/settings/fields/contacts",
                    },
                    {
                        name: t("fields.new-field"),
                        link: "/settings/fields/contacts/new",
                    },
                ] }), _jsx(CustomFieldForm, { status: "new", type: "contacts" })] }));
}
